import { graphql } from '@apollo/client/react/hoc'

import getImageFromEntry, {
  MASTER,
  SQUARE,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import { ApplicationError } from '../../helpers/errors'
import { getOccurrences } from '../../helpers/occurrences'
import { getSponsoredTopic } from '../../helpers/get-sponsored-topic'
import getDescriptiveLocation from '../../helpers/get-descriptive-location'
import { showItem } from '../../helpers/show-item'
import { DateTime, localISODate } from '../../helpers/date-helpers'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ id, centre }) => ({
  context: { version: 1 },
  variables: {
    id,
    centreId: centre.sys.id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

export const mapDataToProps = ({
  ownProps: { centre: ownCentre, id, slug },
  data: { centre: respCentre, loading, error },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!respCentre || !respCentre.offer) {
    // return {
    //   error: new NotFoundError(),
    // }
    const expiredOfferText = {
      category: 'Offer',
      topic: 'Offer',
      title: 'Sorry, that offer is no longer valid',
      body: `The offer you selected is no longer valid.`,
    }
    return {
      entry: {
        ...expiredOfferText,
        store: null,
      },
    }
  } else if (slug !== respCentre.offer.slug) {
    return {
      redirect: `/${ownCentre.slug}/offer/${id}/${respCentre.offer.slug}`,
    }
  }

  const { offer } = respCentre
  const allStores = (offer.stores || []).filter(
    store => store.centre.sys.id === ownCentre.sys.id
  )
  const store = allStores.length === 1 ? allStores[0] : null

  const now = DateTime.local({ timeZone: respCentre.timeZone })
  const expiredOfferText = {
    category: 'Offer',
    topic: 'Offer',
    title: 'Sorry, that offer has expired',
    body: `The offer you selected has expired.`,
  }

  const location = getDescriptiveLocation({
    ...(store &&
      store.physicalAddress && {
        physicalAddress: store.physicalAddress,
      }),
    ...(store && { storeTitle: store.storeTitle }),
  })

  if (showItem(now, ownCentre.timeZone, offer)) {
    return {
      entry: {
        category: 'Offer',
        topic: getSponsoredTopic(offer),
        title: offer.title,
        experiences: offer.experiences,
        retailCategories: offer.retailCategories,
        stores: offer.stores,
        topics: offer.topics,
        slug: offer.slug,
        shortDescription: offer.shortDescription,
        desktopImage: getImageFromEntry(offer, MASTER),
        mobileImage: getImageFromEntry(offer, STANDARD),
        evolvedImage: getImageFromEntry(offer, SQUARE),
        body: offer.bodyCopy,
        termsAndConditions: offer.termsAndConditions,
        occurrences: getOccurrences(false, offer, ownCentre.timeZone),
        typename: offer.__typename,
        location,
        store,
        analyticsMetadata: offer.analyticsMetadata,
      },
    }
  } else {
    return {
      entry: {
        ...expiredOfferText,
        store,
      },
    }
  }
}

const withOfferDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withOfferDetail
